var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserOutlineWhite = function SvgUserOutlineWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3864"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.053 19.786H5.637v-2.057a4.892 4.892 0 0 1 4.885-4.888h1.643a4.893 4.893 0 0 1 4.888 4.888v2.056zm-6.53-6.2a4.15 4.15 0 0 0-4.146 4.146v1.314h9.937v-1.314a4.152 4.152 0 0 0-4.148-4.146zm.821-2.615a4.183 4.183 0 0 1-4.178-4.178 4.184 4.184 0 0 1 4.178-4.181 4.185 4.185 0 0 1 4.181 4.181 4.184 4.184 0 0 1-4.181 4.176zm0-7.617a3.443 3.443 0 0 0-3.438 3.438 3.443 3.443 0 0 0 3.438 3.438 3.444 3.444 0 0 0 3.441-3.438 3.444 3.444 0 0 0-3.441-3.44z",
    "data-name": "Path 11596"
  }))));
};
export default SvgUserOutlineWhite;